import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle2, XCircle, Loader2, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useApp } from '../context/AppContext';
import { usePaymentStatus } from '../hooks/usePaymentStatus';

const StatusCard = ({ icon: Icon, tone, title, desc, action, testId, spin = false }) => (
  <div className="min-h-[70vh] flex items-center justify-center px-4 py-16">
    <div className="w-full max-w-md bg-white rounded-3xl border border-[#EFEAE0] p-10 text-center shadow-sm" data-testid={testId}>
      <div className="w-16 h-16 rounded-full mx-auto flex items-center justify-center mb-4" style={{ backgroundColor: `${tone}1A` }}>
        <Icon className={`w-9 h-9 ${spin ? 'animate-spin' : ''}`} style={{ color: tone }} />
      </div>
      <h1 className="text-2xl font-black text-[#1A1A1A]">{title}</h1>
      <p className="text-[#7A7468] mt-2">{desc}</p>
      {action}
    </div>
  </div>
);

const primaryBtn = 'mt-6 bg-[#0F8B5C] hover:bg-[#0A6E47] text-white';

export const PaymentSuccess = () => {
  const { t } = useApp();
  const [params] = useSearchParams();
  const status = usePaymentStatus(params.get('session_id'));

  const views = {
    polling: { icon: Loader2, spin: true, tone: '#0F8B5C', title: t('pay.verifying'), desc: t('pay.wait'), testId: 'payment-polling' },
    paid: { icon: CheckCircle2, tone: '#0F8B5C', title: t('pay.success'), desc: t('pay.successDesc'), testId: 'payment-success',
      action: <Link to="/dashboard"><Button className={primaryBtn} data-testid="payment-go-dashboard">{t('pay.goDash')} <ArrowRight className="w-4 h-4 ml-2" /></Button></Link> },
    expired: { icon: XCircle, tone: '#E8814A', title: t('pay.failed'), desc: t('pay.failedDesc'), testId: 'payment-failed',
      action: <Link to="/pricing"><Button variant="outline" className="mt-6" data-testid="payment-retry">{t('pay.retry')}</Button></Link> },
  };
  return <StatusCard {...(views[status] || views.expired)} />;
};

export const PaymentCancel = () => {
  const { t } = useApp();
  return (
    <StatusCard
      icon={XCircle} tone="#7A7468" title={t('pay.cancelled')} desc={t('pay.cancelledDesc')} testId="payment-cancelled"
      action={<Link to="/pricing"><Button className={primaryBtn} data-testid="payment-back-pricing">{t('pay.backPricing')}</Button></Link>}
    />
  );
};
